// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playkit-text{color:#fff;font-size:16px;font-weight:400;line-height:21px;margin-bottom:16px;letter-spacing:0;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;max-width:100%}.playkit-comparisonText{color:#fff;font-size:16px;font-weight:400;line-height:21px;margin-bottom:16px;letter-spacing:0;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;max-width:100%;position:absolute;visibility:hidden;pointer-events:none}.playkit-container{display:inline-block;max-width:100%;position:relative}", ""]);
// Exports
exports.locals = {
	"text": "playkit-text",
	"comparisonText": "playkit-comparisonText",
	"container": "playkit-container"
};
module.exports = exports;
